import { connect } from "react-redux";

import Users from "./Users";
import {
  init,
  updateUserClients,
  updateAclOfServiceClient,
  updateUserRole,
  updateUserSector,
  updateUserKpis,
  updateFiltersFront,
  setCurrentFilters
} from "../../../redux/actions/userActions";

const mapStateToProps = state => {
  return {
    sectorsList: state.allSectors,
    clientsList: state.user.clientsList || [],
    kpisList: state.stats.kpis || [],
    users: state.user.users || [],
    servicesList: state.user.servicesList || [],
    aclList: state.user.aclList || [],
    rolesList: state.user.rolesList || [],
    currentClientLabel: (state.currentClient || {}).label,
    currentClient: state.currentClient || {},
    currentFilters: state.user.currentFilters,
    token: state.auth.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    init: () => {
      dispatch(init());
    },
    updateUserClients: data => dispatch(updateUserClients(data)),
    updateUserKpi: data => dispatch(updateUserKpis(data)),
    updateAclOfServiceClient: data => dispatch(updateAclOfServiceClient(data)),
    updateUserRole: data => dispatch(updateUserRole(data)),
    updateUserSector: (data, page) => dispatch(updateUserSector(data, page)),
    defineFilterToSelectedUser: email => {
      dispatch(updateFiltersFront("email", [email]));
    },
    removeFilters: () => {
      dispatch(setCurrentFilters({}));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// src/containers/admin/users/UsersContainer.js